import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { ThreadsEntity } from "./threads.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { StyleEntity } from "../po-bom/entittes/style-entity";
import { ThreadSupplierEntity } from "../thread-supplier/thread-supplier.entity";
import { DpomEntity } from "../dpom/entites/dpom.entity";
import { ThreadQtyEntity } from "../thread-qty/thread-qty.entity";
import { PPMDataEntity } from "../dpom/entites/ppm.entity";

@Injectable()
export class ThreadsRepository extends Repository<ThreadsEntity> {
    constructor(@InjectRepository(ThreadsEntity) private userRepository: Repository<ThreadsEntity>
    ) {
        super(userRepository.target, userRepository.manager, userRepository.queryRunner);
    }

    async getThreadsData(): Promise<any[]> {
        const query = this.createQueryBuilder('t')
            .select(`t.thread_id as id, t.style_id as style, tex, part, quality, color_combo  AS colorCombo, color_code AS colorCode,shade_number AS shadeNumber, ts.supplier_name as supplierName `)
            .leftJoin(ThreadSupplierEntity, "ts", 'ts.thread_supplier_id =t.supplier_id')
        return await query.getRawMany()
    }

    async getThreadsTrimsData(req: any): Promise<any[]> {
        const query = this.createQueryBuilder('t')
            .leftJoin(ThreadSupplierEntity, 'ts', 'ts.thread_supplier_id = t.supplier_id')
            .leftJoin(PPMDataEntity, 'd', 'd.po_and_line IN (:...poLines)', { poLines: req.poLines })
            .leftJoin(ThreadQtyEntity, 'tq', 'tq.tex = t.tex AND tq.quality = t.quality AND tq.thread_supplier_id = t.supplier_id AND tq.qty = "<10K"')
            .select([
                't.style_id AS style',
                't.tex as tex',
                't.part as part',
                't.quality as quality',
                't.color_combo AS colorCombo',
                't.color_code AS colorCode',
                't.shade_number AS shadeNumber',
                'ts.supplier_name AS supplierName',
                'tq.mtrs_per_cone',
                `SUM(d.size_qty) as qty`,
                'd.bom_item as item',
                'd.product_code',
                't.combined as combined',
                't.part'
            ])
            .where('t.style_id = d.style_number')
            .andWhere('t.color_code = SUBSTRING_INDEX(d.product_code, "-", -1)')
            .andWhere(`t.combined = 0`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .groupBy('t.style_id, t.tex, t.quality, t.color_combo, t.color_code, t.shade_number, d.product_code, d.bom_item')
            .orderBy('t.tex', 'DESC')
            .addOrderBy('d.bom_item', 'ASC')
            .addOrderBy('d.product_code', 'ASC');
        return await query.getRawMany()
    }

    async getCombinedThreadsTrimData(req: any): Promise<any[]> {
        const query = this.createQueryBuilder('t')
            .leftJoin(ThreadSupplierEntity, 'ts', 'ts.thread_supplier_id = t.supplier_id')
            .leftJoin(PPMDataEntity, 'd', 'd.po_and_line IN (:...poLines)', { poLines: req.poLines })
            .leftJoin(ThreadQtyEntity, 'tq', 'tq.tex = t.tex AND tq.quality = t.quality AND tq.thread_supplier_id = t.supplier_id AND tq.qty = ">10K"')
            .select([
                't.style_id AS style',
                't.tex as tex',
                't.part as part',
                't.quality as quality',
                'ts.supplier_name AS supplierName',
                'tq.mtrs_per_cone',
                `SUM(d.size_qty) as qty`,
                'd.bom_item as item',
                't.combined as combined',
                't.shade_number as shadeNumber',
                't.part'
            ])
            .where('t.style_id = d.style_number')
            .andWhere(`t.combined = 1`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .groupBy('t.style_id, t.tex, d.bom_item')
            .orderBy('t.tex', 'DESC')
            .addOrderBy('d.product_code', 'ASC');
        return await query.getRawMany()
    }
}